// import { useRef } from 'react';
import "../style/exam-result/ER_Denotative.css";
import React from "react";
let option_data = [
  {
    id: 1,
    lesson: "ریاضی",
  },
  {
    id: 2,
    lesson: "فلسفه",
  },
  {
    id: 3,
    lesson: "منطق",
  },
  {
    id: 4,
    lesson: "مبانی موسیقی",
  },
  {
    id: 5,
    lesson: "برنامه نویسی",
  },
];

let data = [
  {
    id: 1,
    correct_choice: 1,
    user_choice: 1,
    correct_percent: 30,
  },
  {
    id: 2,
    correct_choice: 1,
    user_choice: 2,
    correct_percent: 30,
  },
  {
    id: 3,
    correct_choice: 3,
    user_choice: 2,
    correct_percent: 30,
  },
  {
    id: 4,
    correct_choice: 1,
    user_choice: null,
    correct_percent: 30,
  },
  {
    id: 5,
    correct_choice: 3,
    user_choice: 3,
    correct_percent: 30,
  },
  {
    id: 6,
    correct_choice: 4,
    user_choice: null,
    correct_percent: 30,
  },
  {
    id: 7,
    correct_choice: 2,
    user_choice: 2,
    correct_percent: 30,
  },
  {
    id: 8,
    correct_choice: 3,
    user_choice: 1,
    correct_percent: 30,
  },
  {
    id: 9,
    correct_choice: 3,
    user_choice: 2,
    correct_percent: 30,
  },
  {
    id: 10,
    correct_choice: 1,
    user_choice: 2,
    correct_percent: 30,
  },
  {
    id: 11,
    correct_choice: 1,
    user_choice: 1,
    correct_percent: 30,
  },
  {
    id: 12,
    correct_choice: 4,
    user_choice: 4,
    correct_percent: 30,
  },
];

let color_style_list = ["#FFFFFF", "#FFEF1B", "#EE2C2C", "#9DFF6C"];

const ER_Denotative = () => {
  //column setting----------------------
  let dataNum = 0;
  for (let i = 0; i < data.length; i++) {
    dataNum++;
  }
  let column_height = Math.ceil(dataNum / 2) * 50;
  // ---------------------------------------------
  return (
    <div className="er-denotative">
      <div className="er-denotative-title">نتایج تفکیکی</div>
      <div className="er-denotative-subtitle">
        لطفا نام درسی که می خواهید نتایج تفکیکی آن را مشاهده کنید انتخاب کنید
      </div>
      <div className="er-denotative-select-and-guide-container">
        <select name="lessons" id="er-denotative-select-lessons">
          {option_data.map((item) => (
            <option
              key={item.id}
              value={item.lesson}
              className="er-denotative-select-lessons-item"
            >
              {item.lesson}
            </option>
          ))}
        </select>
        <div className="er-denotative-guide">
          <div className="er-denotative-guide-item">
            <div className="er-denotative-guide-item-text">پاسخ صحیح</div>
            <div className="er-denotative-guide-item-box er-dgib1"></div>
          </div>
          <div className="er-denotative-guide-item">
            <div className="er-denotative-guide-item-text">پاسخ نادرست شما</div>
            <div className="er-denotative-guide-item-box er-dgib2"></div>
          </div>
          <div className="er-denotative-guide-item">
            <div className="er-denotative-guide-item-text">پاسخ صحیح شما</div>
            <div className="er-denotative-guide-item-box er-dgib3"></div>
          </div>
        </div>
      </div>
      <div className="er-denotative-table-title-row">
        <div className="er-denotative-table-title-row-item">
          <div className="er-denotative-table-title-row-item-item">
            شماره سوال
          </div>
          <div className="er-denotative-table-title-row-item-item">1</div>
          <div className="er-denotative-table-title-row-item-item">2</div>
          <div className="er-denotative-table-title-row-item-item">3</div>
          <div className="er-denotative-table-title-row-item-item">4</div>
          <div className="er-denotative-table-title-row-item-item">
            درصد کل صحیح
          </div>
        </div>
        <div className="er-denotative-table-title-row-item">
          <div className="er-denotative-table-title-row-item-item">
            شماره سوال
          </div>
          <div className="er-denotative-table-title-row-item-item">1</div>
          <div className="er-denotative-table-title-row-item-item">2</div>
          <div className="er-denotative-table-title-row-item-item">3</div>
          <div className="er-denotative-table-title-row-item-item">4</div>
          <div className="er-denotative-table-title-row-item-item">
            درصد کل صحیح
          </div>
        </div>
      </div>
      <div
        style={{ maxHeight: `${column_height}px` }}
        className="er-denotative-table-data"
      >
        {data.map((item, index) => {
          let a = [0, 0, 0, 0];
          for (let i = 0; i < 4; i++) {
            if (item.correct_choice === i + 1 && !item.user_choice) {
              a[i] = 1;
            } else if (
              item.correct_choice !== i + 1 &&
              item.user_choice === i + 1
            ) {
              a[i] = 2;
            } else if (
              item.correct_choice === i + 1 &&
              item.user_choice !== i + 1
            ) {
              a[i] = 1;
            }
            if (item.correct_choice === i + 1 && item.user_choice === i + 1) {
              a[i] = 3;
            }
          }
          return (
            <React.Fragment key={index}>
              <div key={item.id} className="er-denotative-table-data-item">
                <div className="er-denotative-table-data-row-item-question-number">
                  {index + 1}
                </div>
                <div className="er-denotative-table-data-row-item-choice">
                  <div
                    style={{ backgroundColor: `${color_style_list[a[0]]}` }}
                    className="er-denotative-table-data-row-item-choice-box"
                  ></div>
                </div>
                <div className="er-denotative-table-data-row-item-choice">
                  <div
                    style={{ backgroundColor: `${color_style_list[a[1]]}` }}
                    className="er-denotative-table-data-row-item-choice-box"
                  ></div>
                </div>
                <div className="er-denotative-table-data-row-item-choice">
                  <div
                    style={{ backgroundColor: `${color_style_list[a[2]]}` }}
                    className="er-denotative-table-data-row-item-choice-box"
                  ></div>
                </div>
                <div className="er-denotative-table-data-row-item-choice">
                  <div
                    style={{ backgroundColor: `${color_style_list[a[3]]}` }}
                    className="er-denotative-table-data-row-item-choice-box"
                  ></div>
                </div>
                <div className="er-denotative-table-data-row-item-correct-percent">
                  {item.correct_percent}%
                </div>
              </div>
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
};

export default ER_Denotative;
